module.exports = __webpack_public_path__ + "img/4-4.816d8f9c.svg";